import { PenLine, Scale, CheckCircle2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';


const steps = [
  {
    icon: PenLine,
    title: 'Pubblica',
    body: 'Descrivi cosa ti serve in 2 minuti. Aggiungi foto se aiuta.',
  },
  {
    icon: Scale,
    title: 'Confronta',
    body: 'Ricevi diversi preventivi da più professionisti per farti scegliere serenamente',
  },
  {
    icon: CheckCircle2,
    title: 'Decidi',
    body: 'Scegli chi vuoi e contatti direttamente. Nessun intermediario.',
  },
];

export default function HowItWorksSection() {
  const navigate = useNavigate();

  return (
    <section className="bg-gray-50 py-16">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-[#013776] text-center mb-4">
          Come funziona
        </h2>
        <p className="text-gray-600 text-center mb-12">
          Tre passi, molto semplice
           <br />
            <br />

           Pubblica
            <br />
            <br />
            Scrivi una breve descrizione di ciò che ti serve, puoi aggiungere delle foto per aiutare i professionisti
        </p>

        <div className="grid md:grid-cols-3 gap-8">
          {steps?.map((step) => {
            const Icon = step?.icon;
            return (
              <div key={step?.title} className="flex flex-col items-center">
                <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center mb-4 mx-auto">
                  <Icon size={32} color="#2780b5" />
                </div>
                <h3 className="text-xl font-semibold text-center mb-2">{step?.title}</h3>
                <p className="text-gray-600 leading-relaxed text-center">{step?.body}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-12 text-center">
          <button
            className="inline-flex items-center gap-2 px-6 py-3 bg-[#2780b5] hover:bg-[#104d98] text-white font-semibold rounded-full transition-colors"
            onClick={() => navigate('/registrati-cliente')}
          >
            Pubblica una richiesta gratuita →
          </button>
        </div>
      </div>
    </section>
  );
}